import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { getAddlTxt2Api, saveAddlTxtApi, deleteAddlTxtApi } from "../Api/api";

function AddlText2() {
  // ===== STATES FOR FORM =====
  const [addlText2, setAddlText2] = useState("");
  
  // ===== STATE FOR DATA LIST =====
  const [dataList, setDataList] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  // ===== FETCH DATA ON MOUNT =====
  useEffect(() => {
    fetchData();
  }, []);

  // ===== FETCH DATA =====
  const fetchData = async () => {
    try {
      setLoading(true);
      // Get company short code from localStorage
      const userData = localStorage.getItem("userData");
      console.log("AddlText2 - userData from localStorage:", userData);
      const comShortCode = userData ? JSON.parse(userData).ComShortCode : "";
      console.log("AddlText2 - comShortCode:", comShortCode);
      
      const response = await getAddlTxt2Api(comShortCode);
      console.log("AddlText2 - getAddlTxt2Api response:", response);
      if (response.status === "success" && response.data) {
        // Handle new API response format
        let dataArray;
        if (Array.isArray(response.data[0])) {
          // New format: response.data[0] is the array
          dataArray = response.data[0];
        } else {
          // Original format
          dataArray = response.data;
        }
        
        // Map API response to UI format (ID -> id, ListData -> text)
        const mappedData = dataArray.map(item => ({
          id: item.ID,
          text: item.ListData || ""
          
        }));
        setDataList(mappedData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // ===== CLEAR FORM =====
  const clearForm = () => {
    setAddlText2("");
    setEditingId(null);
  };

  // ===== SAVE ITEM =====
const saveItem = async () => {
  if (!addlText2.trim()) {
    alert("Please enter Addl Text 2");
    return;
  }

  try {
    setLoading(true);

    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const comShortCode = userData.ComShortCode;

    if (!comShortCode) {
      alert("Company Short Code not found. Please login again.");
      return;
    }

    const payload = {
      ListData: addlText2,
      ComShortCode: comShortCode
    };

    const response = await saveAddlTxtApi(payload);

    if (response.status === "success") {
      fetchData(); // Better to refresh from DB
      clearForm();
      alert(response.message || "Record created successfully");
    }
  } catch (error) {
    console.error("Error saving data:", error);
    alert("Failed to save data");
  } finally {
    setLoading(false);
  }
};

  // ===== EDIT ITEM =====
  const editItem = (item) => {
    setAddlText2(item.text);
    setEditingId(item.id);
  };

  // ===== UPDATE ITEM =====
  const updateItem = () => {
    if (!addlText2.trim()) {
      alert("Please enter Addl Text 2");
      return;
    }

    const updatedList = dataList.map(item => 
      item.id === editingId 
        ? { ...item, text: addlText2 }
        : item
    );

    setDataList(updatedList);
    clearForm();
  };

  // ===== DELETE ITEM =====
  const deleteItem = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        setLoading(true);
        const response = await deleteAddlTxtApi(id);
        
        if (response.status === "success") {
          const filteredList = dataList.filter(item => item.id !== id);
          setDataList(filteredList);
          if (editingId === id) {
            clearForm();
          }
          alert(response.message || "Record deleted successfully");
        } else {
          alert(response.message || "Failed to delete record");
        }
      } catch (error) {
        console.error("Error deleting data:", error);
        alert("Failed to delete data");
      } finally {
        setLoading(false);
      }
    }
  };

  // ===== STYLES =====
  const panelBox = {
    background: "#f5f7f9",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    padding: "24px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
  };

  const panelTitle = {
    fontSize: "13px",
    fontWeight: 700,
    color: "#1f2937",
    borderBottom: "2px solid #3b82f6",
    paddingBottom: "10px",
    marginBottom: "18px",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  };

  const compactInput = {
    width: "100%",
    height: "38px",
    padding: "6px 12px",
    fontSize: "13px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    background: "#fff",
    marginBottom: "14px",
    boxSizing: "border-box"
  };

  const labelStyle = {
    fontSize: "12px",
    fontWeight: 600,
    color: "#374151",
    marginBottom: "6px",
    display: "block"
  };

  const saveBtn = {
    width: "120px",
    background: "#16a34a",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginRight: "10px"
  };

  const updateBtn = {
    width: "120px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginRight: "10px"
  };

  const clearBtn = {
    width: "120px",
    background: "#6b7280",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  };

  const editBtn = {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 12px",
    fontSize: "12px",
    cursor: "pointer",
    marginRight: "5px"
  };

  const deleteBtn = {
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 12px",
    fontSize: "12px",
    cursor: "pointer"
  };

  // ===== HELPER FOR COLUMNS =====
  const col = (size) => ({ flex: `0 0 ${size}%`, maxWidth: `${size}%`, padding: "0 8px", boxSizing: "border-box" });
  const row = () => ({ display: "flex", flexWrap: "wrap", margin: "0 -8px" });

  return ( 
    <div style={{ background: "#e5e7eb", minHeight: "100vh" }}>

      <Sidebar currentPage="addltxt2" />

      <Header title="ADDITIONAL TEXT 2" />

      {/* MAIN CONTENT */}
      <div style={{
        maxWidth: "1300px",
        margin: "30px auto",
        background: "#fff",
        padding: "30px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
      }}>

        <div style={row()}>

          {/* LEFT PARTITION - ADD NEW ITEM */}
          <div style={{ ...col(33), marginBottom: "20px" }}>
            <div style={panelBox}>
              <div style={panelTitle}>ADD NEW ITEM</div>

              <div style={labelStyle}>Addl Text 2</div>
              <input 
                style={compactInput} 
                value={addlText2} 
                onChange={(e) => setAddlText2(e.target.value)}
                placeholder="Enter additional text..."
              />

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                {editingId ? (
                  <>
                    <button style={updateBtn} onClick={updateItem}>
                      UPDATE
                    </button>
                    <button style={clearBtn} onClick={clearForm}>
                      CANCEL
                    </button>
                  </>
                ) : (
                  <button style={saveBtn} onClick={saveItem}>
                    SAVE
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT PARTITION - EXISTING ITEMS */}
          <div style={{ ...col(67), marginBottom: "20px" }}>
            <div style={panelBox}>
              <div style={panelTitle}>EXISTING ITEMS</div>

              {dataList.length === 0 ? (
                <div style={{ textAlign: "center", color: "#6b7280", padding: "40px 0" }}>
                  No items found. Add a new item to get started.
                </div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ borderBottom: "2px solid #e5e7eb" }}>
                      <th style={{ textAlign: "left", padding: "12px 8px", fontSize: "12px", fontWeight: 700, color: "#374151" }}>ID</th>
                      <th style={{ textAlign: "left", padding: "12px 8px", fontSize: "12px", fontWeight: 700, color: "#374151" }}>ADDITIONAL TEXT 2</th>
                      <th style={{ textAlign: "center", padding: "12px 8px", fontSize: "12px", fontWeight: 700, color: "#374151" }}>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataList.map((item) => (
                      <tr key={item.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                        <td style={{ padding: "12px 8px", fontSize: "13px", color: "#6b7280" }}>{item.id}</td>
                        <td style={{ padding: "12px 8px", fontSize: "13px", color: "#1f2937" }}>{item.text}</td>
                        <td style={{ padding: "12px 8px", textAlign: "center" }}>
                         
                          <button 
                            style={deleteBtn} 
                            onClick={() => deleteItem(item.id)}
                          >
                            DELETE
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AddlText2;
